/*
 * Copyright (c) 2026.
 * Spin in het Web B.V. Apeldoorn.
 * Deze software mag alleen gebruikt / bekeken / gewijzigd worden volgens de voorwaarden die zijn vastgelegd in een bijbehorende schriftelijke overeenkomst met Spin in het Web B.V.
 */

/**
 * Hoofdbestand van de applicatie: start `App` met de configuratie uit `app.config.ts`.
 *
 * Tot golf 4f had deze bundel twee ingangen: met `<dl-app>` in de pagina de hele applicatie, zonder
 * dat de zeventien componenten als custom elements voor de AngularJS-pagina. Die tweede ingang is met
 * AngularJS weggegaan.
 *
 * Gegenereerd met Junie (AI), 03-03-2026
 * Auteur: Jelmer Jellema - Spin in het Web B.V
 */
import 'zone.js';
import {bootstrapApplication} from '@angular/platform-browser';
import {App} from './app/app';
import {appConfig} from './app/app.config';

bootstrapApplication(App, appConfig).catch(fout => console.error(fout));
